/**
 * Posts contact fields to the Shopify-only Salesforce Case API.
 * Does NOT preventDefault — Shopify hCaptcha requires a real user submit.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function readPayload(form) {
    var nameEl = form.querySelector('#ContactForm-name, [name="contact[Name]"]');
    var emailEl = form.querySelector('#ContactForm-email, [name="contact[email]"]');
    var phoneEl = form.querySelector('#ContactForm-phone, [name="contact[Phone]"]');
    var messageEl = form.querySelector('#ContactForm-body, [name="contact[Message]"]');

    return {
      name: (nameEl && nameEl.value ? nameEl.value : '').trim(),
      email: (emailEl && emailEl.value ? emailEl.value : '').trim(),
      phone: (phoneEl && phoneEl.value ? phoneEl.value : '').trim() || null,
      message: (messageEl && messageEl.value ? messageEl.value : '').trim(),
    };
  }

  function sendToSalesforce(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'cors',
    }).catch(function () {
      /* Native Shopify submit still runs; do not block contact email */
    });
  }

  ready(function () {
    var cfg = window.LLContactSalesforce || {};
    if (!cfg.enabled || !cfg.url) return;

    var form = document.getElementById(cfg.formId || 'ContactForm');
    if (!form) return;

    form.addEventListener('submit', function () {
      if (form.dataset.sfQueued === '1') return;
      form.dataset.sfQueued = '1';

      var payload = readPayload(form);
      if (!payload.name || !payload.email || !payload.message) return;

      // Fire-and-forget so Shopify captcha + native /contact POST still work.
      sendToSalesforce(cfg.url, payload);
    });
  });
})();
